<template>
  <div class="comment-panel">
    <a-collapse v-model="activeKeys" :bordered="false">
      <template #expandIcon="props">
        <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
      </template>
      <a-collapse-panel key="1" class="comment-item-panel">
        <span slot="header">
          <a-badge :count="commentCount"><span class="head-example">评论</span></a-badge>
        </span>
        <div class="comment-component">
          <!-- 评论编辑区域 -->
          <div class="comment-edit-container">
            <a-avatar :src="$store.state.userInfo.avatar_url" class="custom-comment-avatar" />
            <div class="comment-edit-content">
              <!-- 默认状态：占位符 -->
              <div v-show="!isEdit" class="comment-edit-placeholder" @click="onAddComment">
                <span class="placeholder-text">添加评论...</span>
              </div>

              <!-- 编辑状态：富文本编辑器 -->
              <div v-show="isEdit" class="comment-edit-form">
                <a-form-model ref="form" :model="form" :rules="rules">
                  <a-form-model-item prop="content">
                    <vditor-editor v-model="form.content" :height="240" />
                  </a-form-model-item>
                </a-form-model>
                <div class="comment-edit-actions">
                  <a-button type="primary" style="margin-right: 16px" :loading="submitLoading" @click="onSubmit">确定</a-button>
                  <a-button @click="onClose">取消</a-button>
                </div>
              </div>
            </div>
          </div>

          <!-- 评论列表 -->
          <a-spin :spinning="loading">
            <a-empty v-if="!loading && !ticketInfo.reply?.length" description="暂无评论" />
            <div v-else>
              <div v-for="(comment, index) in ticketInfo.reply" :key="index" class="custom-comment-item">
                <a-avatar :src="comment.reporter.avatarUrl" class="custom-comment-avatar" />
                <div class="custom-comment-main">
                  <div class="custom-comment-header">
                    <div class="custom-comment-author">
                      <span>{{ comment.reporter.nickName }}</span>
                    </div>
                    <div class="custom-comment-time">
                      <a-tooltip :title="getFormattedTime(comment.createdTime)">
                        {{ getFormattedTime(comment.createdTime) }}
                      </a-tooltip>
                    </div>
                  </div>
                  <div class="custom-comment-content">
                    <vditor-preview :content="buildContent(comment)" />
                  </div>
                </div>
              </div>
            </div>
          </a-spin>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { ticketReply } from '@/api/event/problem';
import VditorEditor from '@/components/VditorEditor';
import VditorPreview from '@/components/VditorEditor/preview';

export default {
  components: { VditorEditor, VditorPreview },
  props: {
    ticketInfo: {
      type: Object,
      default: null
    },
    activeKey: {
      type: Array,
      default() {
        return ['1'];
      }
    }
  },
  data() {
    return {
      form: {
        content: ''
      },
      isEdit: false,
      loading: false,
      submitLoading: false,
      rules: {
        content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
      },
      activeKeys: [],
      commentCount: 0
    };
  },
  watch: {
    activeKey: {
      immediate: true,
      handler(val) {
        this.activeKeys = val;
      }
    },
    'ticketInfo.reply': {
      immediate: true,
      handler(val) {
        this.commentCount = val?.length || 0;
      }
    }
  },
  methods: {
    getFormattedTime(createdTime) {
      return createdTime.substring(0, 19);
    },
    buildContent(comment) {
      if (!comment || !Array.isArray(comment.images)) {
        return comment.desc;
      }
      let content = comment.desc;
      for (const image of comment.images) {
        const url = image;
        const cardString = image.includes('mp4') ? `![Screenrecording.mp4](${url})` : `![image.png](${url})`;
        content += cardString;
      }
      return content;
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          const regex = /!\[.*\]\((https?:\/\/[^\s]+\.(?:png|jpe?g))\)/gi;
          const matches = Array.from(this.form.content.matchAll(regex));
          const imageLinks = [];
          for (const match of matches) {
            const link = match[1];
            imageLinks.push(link);
            this.form.content = this.form.content.replace(match[0], '');
          }

          const replyInfo = {
            desc: this.form.content.replace(/\n/g, ''),
            from: this.ticketInfo.from,
            createdTime: '',
            images: imageLinks,
            qiyuTicketId: this.ticketInfo.qiyuTicketId,
            reporter: {
              nickNanme: '',
              avatarUrl: ''
            },
            ticketId: this.ticketInfo.id
          };

          const localReplyList = this.ticketInfo;
          if (localReplyList.reply == null) {
            localReplyList.reply = [];
          }
          localReplyList.reply.push(replyInfo);

          ticketReply({ replyInfo })
            .then(() => {
              this.onClose();
              this.$emit('callback');
            })
            .catch(() => {})
            .finally(() => {
              this.submitLoading = false;
            });
        }
      });
    },
    onAddComment() {
      if (!this.activeKeys.includes('1')) {
        this.activeKeys.push('1');
      }
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = true;
      this.$nextTick(() => {
        const input = this.$el.querySelector('textarea');
        if (input) input.focus();
      });
    },
    onClose() {
      this.$refs.form.resetFields();
      this.form.content = '';
      this.isEdit = false;
    }
  }
};
</script>

<style lang="less" scoped>
.comment-panel {
  // border-top: 1px solid #e8e8e8;
  border-radius: 4px;
  // padding: 8px 0 0 0;
  position: relative;
  overflow: visible;
}

.comment-item-panel {
  border-radius: 4px;
  border: 0;
  background: #fff;
  overflow: visible;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.head-example {
  display: inline-block;
  padding-right: 8px;
  font-weight: 500;
  font-size: 15px;
}

:deep(.ant-badge-count) {
  height: 14px;
  min-width: 14px;
  line-height: 14px;
  font-size: 8px;
  padding: 0 3px;
  background-color: #1890ff;
}

// 确保collapse组件不会限制tooltip显示
:deep(.ant-collapse) {
  overflow: visible;
}

:deep(.ant-collapse-content) {
  overflow: visible;
}

:deep(.ant-collapse-content-box) {
  overflow: visible;
  padding: 8px;
}

.comment-component {
  max-width: 960px;
  width: 100%;
  box-sizing: border-box;

  :deep(.vditor-reset) {
    img {
      max-width: 100% !important;
      height: auto !important;
      margin: 8px 0;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      object-fit: contain;
      display: block;
    }
  }

  :deep(.vditor-preview) {
    img {
      max-width: 100% !important;
      height: auto !important;
      margin: 8px 0;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      object-fit: contain;
      display: block;
    }
  }
}

.comment-edit-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  position: relative;
  overflow: visible;
  padding: 0 8px;

  .comment-edit-content {
    flex: 1;
    min-width: 0;
  }

  .comment-edit-placeholder {
    min-height: 36px;
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: #fafafa;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #f5f5f5;
      border-color: #d9d9d9;
    }

    .placeholder-text {
      font-size: 14px;
      color: #999;
      font-style: italic;
    }
  }

  .comment-edit-form {
    position: relative;

    .comment-edit-actions {
      margin-top: 12px;
    }
  }
}

.custom-comment-item {
  display: flex;
  align-items: flex-start;
  // margin-bottom: 12px;
  background: transparent;
  transition: all 0.2s ease;
  padding: 8px;

  &:hover {
    background-color: #f8f9fa;
    border-radius: 6px;
  }
}

.custom-comment-avatar {
  margin-right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  flex-shrink: 0;
}

.custom-comment-main {
  flex: 1;
  min-width: 0;
}

.custom-comment-header {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  margin-bottom: 8px;

  .custom-comment-author {
    font-size: 14px;
    font-weight: normal;
  }

  .custom-comment-time {
    font-size: 13px;
    color: #b0b0b0;
  }
}

.custom-comment-content {
  font-size: 15px;
  color: #222;
  word-break: break-word;
  line-height: 1.8;
  max-width: 100%;
  overflow-wrap: break-word;
  overflow: hidden;

  :deep(p) {
    margin: 8px 0;
    max-width: 100%;
    overflow-wrap: break-word;
  }
}

:deep(.ant-form-item) {
  margin-bottom: 8px;
}
</style>
